import React, { useState } from 'react';
import './Pages.css';

function Contact() {
    
    return (
      <div className="page-container">
      <section className="o11y">
        <h1 className="o11y-title">Contact Us</h1>
        <p className="o11y-text">If you have any questions or need assistance, please send a message to one of the following channels</p>

        <h3 className="o11y-text">Slack</h3>
        <p className="o11y-text">Section for slack</p>

        <h3 className="o11y-text">Email</h3>
        <p className="o11y-text">Mail to information</p>
      </section>
    </div>
  );
}

export default Contact;